import qs from 'querystring'
 
import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import STATUS_CODE from '../constant/status_code'


const url = COOKIECONSTANT.REQUEST_HOST
const emptyProductListData = {
  page: {
    total: 0,
  },
  list: [],
}
const getSearchResult = (data) => {
  return new Promise((resolve, reject) => {
    data = {
      ...data,
      // wd: encodeURIComponent(data.wd)
    }
    const queryUrl = `${url}?${qs.stringify(data)}`

    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.product.search',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getSearchResultV2 = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = url
    data = JSON.stringify(data)
    Api.post(queryUrl, data, {
      headers: {
        'X-Host': 'mall.product.search.v2',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getSearchResultV3 = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = url
    data = JSON.stringify(data)
    Api.post(queryUrl, data, {
      headers: {
        'X-Host': 'mall.product.search.v3',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getSearchHotWords = data => {
  return new Promise((resolve, reject) => {
    Api.get(url, {
      headers: {
        'X-Host': 'mall.cfg.search.hot-words',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getProductBySearch = data => {
  return new Promise((resolve, reject) => {
    const query = qs.stringify(data)
    // Api.get('http://mock.io.sodalife.club/mock/5a0bb4ea919060339e5c28d8/example/api/product/recommend-list')
    Api.get(`${url}?${query}`, {
      headers: {
        'X-Host': 'mall.product.recommend-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    })
    .then(data => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status == 0) {
        return resolve(data.data)
      }
      reject(data.msg)
    }, e => {
      reject(e)
    })
  })
}
/* 搜索底纹/热搜关键词 */
const getShadingHotKeywords = () => {
  return new Promise((resolve, reject) => {
    // Api.get('http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/search/keywords', {
    Api.get(`${url}`, {
      headers: {
        'X-Host': 'mall.search.keywords',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    })
    .then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
/* 搜索词关联列表 */
const getKeywordList = (params) => {
  return new Promise((resolve, reject) => {
    // Api.post(`http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/search/match-keywords`, JSON.stringify(params), {
    Api.post(`${url}`, JSON.stringify(params), {
      headers: {
        'X-Host': 'mall.search.match-keywords',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    })
    .then(data => {
      if(data.status != 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
export default {
  getSearchResult,
  getSearchResultV2,
  getSearchResultV3,
  getSearchHotWords,
  getProductBySearch,
  getShadingHotKeywords,
  getKeywordList,
}
